import React from "react";
import { Container } from "react-bootstrap";
import Index from "Components/Index";
import { StoreSection } from "../../../../redux/services/store/storeCategoryPagesApi";

type Props = {
  section: StoreSection;
  categorySlug: string;
};

const CategoryProductGridSection: React.FC<Props> = ({
  section,
  categorySlug,
}) => {
  const settings = section.settings_json || {};
  const useAllProducts = settings.products_source === "all_products";

  return (
    <section className="position-relative section mt-4">
      <Container fluid>
        <Index
          name={settings.name ?? "sidebar flex-shrink-0"}
          cxxl={settings.cxxl ?? "3"}
          clg={settings.clg ?? "4"}
          cmd={settings.cmd ?? "6"}
          cxl={settings.cxl}
          category_slug={useAllProducts ? null : categorySlug}
          category_id={useAllProducts ? null : settings.category_id ?? null}
          disableRouteCategoryFilter={useAllProducts}
        />
      </Container>
    </section>
  );
};

export default CategoryProductGridSection;
